export const skills = [
  {
    title: "AutoCAD",
    description: "Advanced engineering design tools used for precise 2D drafting, 3D modeling, and structural computations.",
    image: "https://media.arcengltd.com/skill-images/AutoCAD.webp",
  },
  {
    title: "Solid Works",
    description: "Hands-on expertise in structural analysis, piping layouts, skid design, and engineering optimization.",
    image: "https://media.arcengltd.com/skill-images/SolidWorks.webp",
  },
  {
    title: "STAAD.Pro",
    description: "High-end CAD and CAE tools enabling efficient design workflows and detailed model visualization.",
    image: "https://media.arcengltd.com/skill-images/STAAD.Pro.webp",
  },
  {
    title: "3D Solid Modelling",
    description: "Comprehensive modelling and documentation tools used across mechanical, civil, and energy sectors.",
    image: "https://media.arcengltd.com/skill-images/3D_Solid_Modelling.webp",
  },
  {
    title: "2D Technical Documentation",
    description: "Professional-grade drafting, analysis, and documentation applications for engineering teams.",
    image: "https://media.arcengltd.com/skill-images/2D_Technical_Documentation.webp",
  },
  {
    title: "Structural Analysis",
    description: "Advanced simulation and validation tools for structural and mechanical designs.",
    image: "https://media.arcengltd.com/skill-images/Structural_Analysis.webp",
  },
  {
    title: "Piping Design",
    description: "Specialized software for piping, instrumentation, and CAD optimization.",
    image: "https://media.arcengltd.com/skill-images/Piping_Design.webp",
  },
  {
    title: "Skid & Packaging Design",
    description: "3D CAD tools for assembly, analysis, and detailed project documentation.",
    image: "https://media.arcengltd.com/skill-images/Skid_Packaging_Design.webp",
  },
  {
    title: "Value Engineering",
    description: "Simulation tools for civil and structural engineering projects.",
    image: "https://media.arcengltd.com/skill-images/Value_Engineering.webp",
  },
  {
    title: "Advanced Design Infrastructure",
    description: "Collaboration-focused CAD suite for multi-discipline engineering teams.",
    image: "https://media.arcengltd.com/skill-images/Advance_Design_Infrastructure.webp",
  },
];